export default __webpack_public_path__ + "static/living-church-header-logo-white-4a45e8adea4ad37666ce5b8b1413ba70.svg";